import ProjectsProxy from '@/proxies/Projects';
import {
  ENGINE_STATUS_LOADING,
  ENGINE_STATUS_STOPPED,
} from '@/constants';

export default {
  getJobName({ rootGetters }, jobId) {
    return rootGetters['projects/items'].find(el => el.id === jobId)?.name || null;
  },

  async resend({ getters, dispatch, rootGetters }, payload) {
    const proxy = new ProjectsProxy();
    const { id, phase } = payload;
    const jobName =  await dispatch('getJobName', id);
    const options = { ...getters.options, phase: phase || getters.options.phase };
    const rpcServerStatus = rootGetters['usage/rpcServerRunning'];

    try {
      if (rpcServerStatus === ENGINE_STATUS_STOPPED) {
        dispatch('usage/changeEngineStatus', ENGINE_STATUS_LOADING, { root: true });
      }
      await proxy.runJob(id, options);
      dispatch('projects/refresh', {}, { root: true });
      dispatch('notification/success', ['confirmationmessage.project_restarted', { jobName }], { root: true });
      dispatch('usage/getEngineStatus', null, { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_resubmit_project', { root: true });
    }
  },

  async runBallPossession({ dispatch }, jobId) {
    const proxy = new ProjectsProxy();
    try {
      await proxy.runBallPossession(jobId);
      const jobName =  await dispatch('getJobName', jobId);
      dispatch('notification/success', ['confirmationmessage.ball_possession', { jobName }], { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_restart_ball_possession', { root: true });
    }
  },

  async runEvents({ dispatch }, jobId) {
    const proxy = new ProjectsProxy();
    try {
      await proxy.runEvents(jobId);
      const jobName = await dispatch('getJobName', jobId);
      dispatch('notification/success', ['confirmationmessage.game_events', { jobName }], { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_restart_events', { root: true });
    }
  },

  async runInterpolationForJob({ dispatch }, jobId) {
    const proxy = new ProjectsProxy();
    try {
      await proxy.runInterpolationForJob(jobId);
      const jobName =  await dispatch('getJobName', jobId);
      dispatch('notification/success', ['confirmationmessage.project_restarted', { jobName }], { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_resubmit_project', { root: true });
    }
  },

  async runJerseys({ dispatch }, jobId) {
    const proxy = new ProjectsProxy();
    try {
      await proxy.refreshJerseys({ jobId });
      const jobName =  await dispatch('getJobName', jobId);
      dispatch('notification/success', ['confirmationmessage.jerseys_restarted', { jobName }], { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_restart_jerseys', { root: true });
    }
  },

  async runPostTracking({ dispatch }, jobId) {
    const proxy = new ProjectsProxy();
    try {
      await proxy.runPostTracking(jobId);
      const jobName =  await dispatch('getJobName', jobId);
      dispatch('notification/success', ['confirmationmessage.post_tracking', { jobName }], { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_restart_post_tracking', { root: true });
    }
  },
  
  async runRebuildPostTracking({ dispatch }, jobId) {
    const proxy = new ProjectsProxy();
    try {
      await proxy.runRebuildPostTracking(jobId);
      const jobName =  await dispatch('getJobName', jobId);
      dispatch('notification/success', ['confirmationmessage.rebuild_post_tracking', { jobName }], { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_rebuild_post_tracking', { root: true });
    }
  },

  async runRefreshTracks({ dispatch }, jobId) {
    const proxy = new ProjectsProxy();
    try {
      await proxy.refreshTracks(jobId);
      const jobName = await dispatch('getJobName', jobId);
      await dispatch('tracksMapping/getItems', jobId, { root: true });
      dispatch('notification/success', ['confirmationmessage.tracks_restarted', { jobName }], { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_refresh_tracks', { root: true });
    }
  },

  async runStatistic({ dispatch }, jobId) {
    const proxy = new ProjectsProxy();
    try {
      await proxy.runStatistic(jobId);
      const jobName =  await dispatch('getJobName', jobId);
      dispatch('notification/success', ['confirmationmessage.game_statistic', { jobName }], { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_restart_statistic', { root: true });
    }
  },

  async runZCoordinateForBall({ dispatch }, jobId) {
    const proxy = new ProjectsProxy();
    try {
      await proxy.runZCoordinateForBall(jobId);
      const jobName =  await dispatch('getJobName', jobId);
      dispatch('notification/success', ['confirmationmessage.ball_z_coord', { jobName }], { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_restart_ball_z_coord', { root: true });
    }
  },
};
